import styled from 'styled-components';
import { Flex } from '../containers/Flex/Flex.component';

export const ModalBody = styled(props => <Flex px={6} pb={6} {...props} />)`
  overflow: auto;
`;

ModalBody.displayName = 'Modal.Body';
